import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { isFlatDesign } from '../themes/const.esm.js';
import { getSafeShade } from '../utils/colors.esm.js';
import { resolveColor } from '../utils/styled-props.esm.js';

var resolveInputBoxShadow = function resolveInputBoxShadow(theme, state, inset) {
  var blur = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var color = resolveColor(theme, state);
  var isFlatDesign$1 = isFlatDesign(theme);
  return color ? _objectSpread2({}, isFlatDesign$1 ? {} : {
    boxShadow: "".concat(inset ? 'inset ' : '', "0px 0px ").concat(blur, "px ").concat(color)
  }) : {};
};
var resolveInputOutline = function resolveInputOutline(theme, state, inset, disabled) {
  var blur = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var color = resolveColor(theme, state);
  var isFlatDesign$1 = isFlatDesign(theme);
  return color ? _objectSpread2({
    border: "1px solid ".concat(getSafeShade(0.05, color))
  }, isFlatDesign$1 || disabled ? {} : resolveInputBoxShadow(theme, state, inset, blur)) : {};
};

export { resolveInputBoxShadow, resolveInputOutline };
//# sourceMappingURL=input-element-utils.esm.js.map
